import React from 'react';

import styles from './CheckboxIndicator.module.scss';

export interface ICheckboxIndicatorProps {
  checked?: boolean | 'mixed';
  color?: string;
  size?: 'default' | 'small';
}

const Background = (props) => (
  <rect fill={props.fill} className={props.className} width="24" height="24" rx="3" ry="3" />
);

const Outline = (props) => (
  <path
    fill={props.fill}
    className={props.className}
    d={`M21,2a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H21m0-2H3A3,
       3,0,0,0,0,3V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z`}
  />
);

const CheckMark = (props) => (
  <polygon
    fill={props.fill}
    className={props.className}
    points={`17.66 5.64 9.17 14.12 6.34 11.29 4.22 13.41 7.05 16.24 9.17 18.36
             11.29 16.24 19.78 7.76 17.66 5.64`}
  />
);

const IndeterminateMark = (props) => (
  <path
    fill={props.fill}
    className={props.className}
    d="M17.5,14h-11c-0.6,0-1-0.4-1-1v-2c0-0.6,0.4-1,1-1h11c0.6,0,1,0.4,1,1v2C18.5,13.6,18.1,14,17.5,14z"
  />
);

export const CheckboxIndicator: React.SFC<ICheckboxIndicatorProps> = (props) => {
  const size = props.size === 'small' ? 18 : 24;

  if (props.color) {
    return (
      <svg role="img" width={size} height={size} viewBox="0 0 24 24" className={styles.indicator}>
        <Background className={styles.indicatorBackgroundNoColor} fill={props.color} />
        <Background className={styles.indicatorBackgroundHide} fill="white" />
        <Outline className={styles.indicatorOutlineNoColor} fill={props.color} />
        <CheckMark className={styles.indicatorCheckMark} />
        <IndeterminateMark className={styles.indicatorIndeterminate} />
      </svg>
    );
  } else {
    return (
      <svg role="img" width={size} height={size} viewBox="0 0 24 24" className={styles.indicator}>
        <Background className={styles.indicatorBackground} />
        <Outline className={styles.indicatorOutline} />
        <CheckMark className={styles.indicatorCheckMark} />
        <IndeterminateMark className={styles.indicatorIndeterminate} />
      </svg>
    );
  }
};
